import Bugsnag from '@bugsnag/js';
import helperFunctions from '@/utils/helperFunctions';
import store from '../store/index';

export default (passedMessage, err, data = {}) => {
  const error = err instanceof Error ? err : new Error(err);
  Bugsnag.leaveBreadcrumb('customMessage', { message: passedMessage }, 'manual');
  if (store.state.route) {
    Bugsnag.setContext(store.state.route.path);
  }
  // Reset the stack trace if it's an axios error
  const { response } = error;
  if (response && response.config && response.config.isAxios) {
    const stackTrace = new Error().stack;

    if (stackTrace) {
      const lines = stackTrace.split('\n');
      if (lines[0].substring(0, 5) === 'Error') {
        lines.splice(1, 1); // Remove the 2nd line (first line is "Error")
      } else {
        lines.splice(0, 1); // Remove the 1st line
      }
      error.stack = lines.join('\n');
    }
  }
  Bugsnag.notify(error, event => {
    if (error.response?.config?.data) {
      error.response.config.data = helperFunctions.parseAndCleanData(error.response.config.data);
    }
    event.addMetadata('error_response', error.response);
    // Send business & user data by default
    event.addMetadata('custom_meta_data', {
      keys: store.state.business.api,
      business: store.state.business.info,
      user: store.state.user,
      lead: store.state.lead,
      routeList: store.state.routeList,
      ...data,
    });
  });
};
